import {Component, OnInit} from '@angular/core';
import {DegradedModeService} from "./services/degraded-mod-service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(public degradedModeService: DegradedModeService) {}

  title = 'ogrn_front';
  layoutMode = 'static';

  lightMenu = true;

  topbarColor = 'layout-topbar-light';

  inlineUser = false;

  isRTL = false;

  inputStyle = 'outlined';

  ripple = true;

  showDegradedModal: boolean = false;

  ngOnInit() {
    this.degradedModeService.init();

    // S'abonner aux changements du mode dégradé
    this.degradedModeService.isDegradedMode().subscribe(isDegraded => {
      if (isDegraded) {
        this.showDegradedModal = true;
      } else {
        this.showDegradedModal = false;
      }
    });
  }
}
